import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    paper: {
        width: '100%',
        padding: '.5rem',
        margin: '.5rem'
    },
    selectDiv: {
        width: '100%',
        height: '3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    select: {
        width: '96%',
        height: '90%',
        borderRadius: '4px'
    },
    fileBase: {
        margin: '.7rem 0'
    },
    button: {
        margin: '1rem 0',
        minHeight: '2.5rem'
    },

})

export default useStyles